// 资讯模块

const portalList = (r) =>
  require.ensure(
    [],
    () => r(require('../views/info/PortalList.vue')),
    'portalList'
  )

const portaladd = (r) =>
  require.ensure(
    [],
    () => r(require('../views/info/add.vue')),
    'add'
  )


export default [
    //资讯列表
    {
        name: 'list',
        path: '/list',
        component: portalList,
        meta: { title: '资讯列表' },
    },
    {
        name: 'list/manage',
        path: '/list/manage',
        component: portaladd,
        meta: { title: '增删改查' },
    },
]
